module.exports = __webpack_public_path__ + "img/F1M6_new.1b7d6d5d.jpg";